import { useTranslation } from 'react-i18next';
import { SttSelectableItems } from '../all';

type Props = {
    name?: string;
    selected?: number[];
    onChange?: (event: { name: string | undefined; value: unknown }) => void;
    disabled?: boolean;
};

/**
 * SttSelectWeekdays - Present a SttSelectableItems preloaded with the weekdays
 * string name - field name
 * int[] Array selected - values of the selected days: 0,1,2...
 * Function onChange({name, value}) - callback for when selection changes.
 */
export function SttSelectWeekdays({
    selected,
    onChange,
    disabled,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    // TODO: Make Sunday's position locale-dependant?
    return (
        <SttSelectableItems
            disabled={disabled}
            name="weekdays"
            items={[1, 2, 3, 4, 5, 6, 0].map((day: any) => ({
                label: t(`day.${day}.mini`),
                value: day,
            }))}
            selected={selected}
            onChange={onChange as any}
        />
    );
}
